export enum EPhoneErrorMessages {
  Format = 'Телефон должен быть в формате: +7 (123) 456 78 90',
  Required = 'Введите корректное значение',
}
